import { useCallback, useState, type ReactElement, type ReactNode } from 'react';
import { ConfirmDialog } from '@/components/ConfirmDialog';
import { DetailHeaderIconButton } from './DetailHeaderIconButton';

type DetailDeleteHeaderActionProps = {
  onDelete?: () => Promise<void> | void;
  deleteLoading?: boolean;
  dialogTitle: string;
  dialogDescription: ReactNode;
  confirmLabel: string;
  buttonLabel?: string;
};

export const DetailDeleteHeaderAction = ({
  onDelete,
  deleteLoading = false,
  dialogTitle,
  dialogDescription,
  confirmLabel,
  buttonLabel = 'Delete',
}: DetailDeleteHeaderActionProps): ReactElement | null => {
  const [deleteOpen, setDeleteOpen] = useState(false);
  const handleDeleteConfirm = useCallback(() => {
    setDeleteOpen(false);
    if (onDelete) {
      void onDelete();
    }
  }, [onDelete]);

  if (!onDelete) {
    return null;
  }

  return (
    <>
      <ConfirmDialog
        open={deleteOpen}
        title={dialogTitle}
        description={dialogDescription}
        confirmLabel={confirmLabel}
        confirmColor="error"
        loading={deleteLoading}
        onClose={() => {
          setDeleteOpen(false);
        }}
        onConfirm={handleDeleteConfirm}
      />
      <DetailHeaderIconButton
        label={buttonLabel}
        color="error"
        disabled={deleteLoading}
        onClick={() => {
          setDeleteOpen(true);
        }}
      />
    </>
  );
};
